import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { PaginationRequest } from "src/app/models/common/paginationRequest";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import { AppState } from "src/app/store/reducers";
import { GridUtils } from "../../utils/gridUtils";
import {
  setSimpleFilterQuery,
  setAdvancedFilterQuery,
} from "../../utils/tableUtils";

import { AppSessionService } from "../app-session/app-session.service";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class WarehouseService {
  private BASE_URL = this.appSession.baseUrl + "/api/v1/warehouses";

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private appSession: AppSessionService
  ) {}

  getWarehouses(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    return this.http.get(
      this.buildDataUrl(paging, filteringArgs, sortingArgs, headers, "?"),
      { headers }
    );
  }

  getWarehouseBySite(siteCode: string, pageReq?: PaginationRequest): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let url = `${
      this.appSession.baseUrl + "/api/v1/warehouses"
    }/bySite/${siteCode}`;

    if (pageReq) {
      const { realSize, offset, limit } = pageReq;
      url = url + `?real_size=${realSize}&offset=${offset}&limit=${limit}`;
    }

    return this.http.get(url, { headers });
  }

  createWarehouse(warehouse): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(warehouse);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/warehouses"}`;
    return this.http.post(url, data, { headers });
  }

  updateWarehouse(warehouse): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(warehouse);
    const url = `${this.appSession.baseUrl + "/api/v1/devices/warehouses"}/${
      warehouse.code
    }`;
    return this.http.put(url, data, { headers });
  }

  private buildDataUrl(
    pagingArgs: any,
    filteringArgs: any,
    sortingArgs: any,
    header: HttpHeaders,
    path: string
  ): string {
    let baseQueryString = `${
      this.appSession.baseUrl + "/api/v1/devices/warehouses"
    }${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
    }

    query +=
      scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;

    baseQueryString += query;

    return baseQueryString;
  }
}
